import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import * as driversApi from '../api/drivers';
import * as clientTypesApi from '../api/client_types';
import { translate } from '../i18n_text';
import { reactListTablesEnabled } from '../permissions';
import { session } from '../session';
import { BaseLoadingScreen } from './base_loading_screen';
import { GridView } from '../utils/grid_view';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { GridChoices, listLookup } from '../utils/grid_choices';
import {
  DriversListChoices,
  DriversListPage,
  DriversListProps,
  DriversListQuery,
  DriversListRow,
} from 'react-islands';

let template = require('raw-loader!../../templates/drivers.html').default;

class DriversScreen extends BaseLoadingScreen implements ListLoaderDelegate<driversApi.DriverData> {
  listActions: ListHeaderAction[] = [{ title: i18n.t('Add')(), icon: 'add_circle', href: '/drivers/new/' }];

  newDriversTable = reactListTablesEnabled();

  private view = new GridView(
    'drivers',
    new GridChoices<DriversListChoices>(
      {
        client_type: listLookup(clientTypesApi.list, 'clientType'),
      },
      () => ({
        clientType: [],
      })
    )
  );

  tableProps = ko.pureComputed<DriversListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
  }));

  constructor(params: { filters: unknown }) {
    super();

    this.loadedAfter(this.newDriversTable ? this.view.load(params.filters) : Promise.resolve());
  }

  fetch(params: ListRequestParams) {
    return driversApi.list(params);
  }

  private fetchPage = (query: DriversListQuery): Promise<DriversListPage> =>
    this.view.fetchListPage(query, driversApi.list, 'name_prefix', this);

  toRow = (data: driversApi.DriverData): DriversListRow => ({
    id: data.id || '',
    name: translate(data.name_json),
    url: session.toTenantPath(this.getEditUrl(data)),
    clientTypeName: translate(data.client_type.name_json),
    actions: delegateActions(this, data, this.view.reload),
  });

  instantiate(data: driversApi.DriverData) {
    return data;
  }

  getEditUrl(data: driversApi.DriverData) {
    return `/drivers/${data.id}/`;
  }

  remove(id: string) {
    return driversApi.remove(id);
  }

  canRemove(entity: driversApi.DriverData) {
    return true;
  }
}

export let drivers = {
  name: 'drivers',
  viewModel: DriversScreen,
  template: template,
};

ko.components.register(drivers.name, drivers);
